import { OnboardingPages } from '../../../../common/src/pages.ts';
import { SubscribePayment } from './subscribe_payment.tsx';

export const SubscribeStart = () => {
  return <SubscribePayment onboardingPage={OnboardingPages.SubscribeStart} />;
};
